// @flow
import get from 'lodash/get';

import {
  COMPANY_DETAILS_REQUEST,
  COMPANY_DETAILS_UPDATE,
  COMPANY_DETAILS_ERROR,
  COMPANY_DETAILS_RESET,
  FACILITIES_DETAILS_REQUEST,
  FACILITIES_DETAILS_ERROR,
  FACILITIES_DETAILS_UPDATE
} from './constants';

import { connectIncludedData } from './utils';
import { connectIncludedData as connectFacilityIncludedData } from '../../Facility/redux/utils';

import type { State, Action } from '../types';

export const initialState: State = {
  requesting: false,
  requestingFacilities: false,
  data: null,
  facilities: []
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case COMPANY_DETAILS_REQUEST:
      return { ...state, requesting: true };

    case COMPANY_DETAILS_UPDATE:
      return {
        ...state,
        requesting: false,
        data: action.data && connectIncludedData(get(action, 'data'), action.included || [])
      };

    case COMPANY_DETAILS_ERROR:
      return { ...state, requesting: false };

    case FACILITIES_DETAILS_REQUEST:
      return { ...state, requestingFacilities: true };

    case FACILITIES_DETAILS_UPDATE:
      return {
        ...state,
        requestingFacilities: false,
        facilities:
          action.data
          && get(action, 'data', []).map(facility => connectFacilityIncludedData(facility, get(action, 'included', [])))
      };

    case FACILITIES_DETAILS_ERROR:
      return { ...state, requestingFacilities: false };

    case COMPANY_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};
